export default "__VITE_ASSET__rLKbp_gP__"